module.exports = __webpack_public_path__ + "static/media/incoming-call-ringtone.f2e792c.wav";


//////////////////
// WEBPACK FOOTER
// ./static/audio/incoming-call-ringtone.wav
// module id = mQiQ
// module chunks = 24